// extracted by mini-css-extract-plugin
module.exports = {"file--upload":"file--upload__2nJRK"};